import React from "react";

interface EmbedVideoType {
    embedId: string
}

const EmbedVideo = (props: EmbedVideoType) => (
    <div className="embed-video">
        <iframe
            width="480"
            height={360}
            src={`https://www.youtube.com/embed/${props.embedId}?modestbranding=1&rel=0`}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
            title="Embedded youtube"
        />
    </div>
);

export default EmbedVideo;